import { Modal as ModalCore } from '@studiometa/ui';

/**
 * Modal class.
 */
export default class Modal extends ModalCore {
  static config = {
    ...ModalCore.config,
    emits: ['open-index'],
    options: {
      ...ModalCore.config.options,
      styles: {
        type: Object,
        default: () => ({
          modal: {
            active: 'transition-all duration-500 ease-out-expo',
            closed: {
              opacity: 0,
              pointerEvents: 'none',
              visibility: 'hidden',
            },
          },
          container: {
            active: 'transition duration-700 ease-out-expo',
            closed: 'transform scale-90',
          },
        }),
      },
    },
  };

  /**
   * onOpenClick
   * @param {*} e
   * @param {*} index
   */
  onOpenClick(e, index) {
    super.onOpenClick();
    this.$emit('open-index', index);
  }

  /**
   * open
   * @this {Modal & ModalInterface}
   * @returns {Modal}
   */
  open() {
    this.$refs.modal.style.display = '';
    return super.open();
  }

  /**
   * close
   * @this {Modal & ModalInterface}
   */
  async close() {
    await super.close();

    if (!this.isOpen) {
      this.$refs.modal.style.display = 'none';
    }

    return this;
  }
}
